import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import getUserBookmarks from './getUserBookmarks';

const actions = createActions({
  USER: {
    REMOVE_USER_BOOKMARK: (contentId) => ({ contentId }),
    API: {
      REMOVE_USER_BOOKMARK: apiResourceActionCreator('bookmarks'),
    }
  }
});

export const apiAction = (authToken, contentId) => commonApiActions.authenticated.delete(USER_RESOURCE_ENDPOINT(RESOURCES.Bookmarks, contentId), authToken, actions.user.api.removeUserBookmark);

export function* removeUserBookmark(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken, action.payload.contentId));

    const result = yield apiActionResult(actions.user.api.removeUserBookmark);
    if (result.success) {
      yield put(getUserBookmarks.action.user.getUserBookmarks());
    }
  }
};

const configuration = {
  name: 'removeUserBookmark',
  action: actions,
  sagas: removeUserBookmark,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      isUpdating: false
    }),
  }
};

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/removeUserBookmark.js